var map = {
	"./Auth/Login": 7402,
	"./Auth/Login.vue": 7402,
	"./Clients/Create": 374,
	"./Clients/Create.vue": 374,
	"./Clients/Edit": 3464,
	"./Clients/Edit.vue": 3464,
	"./Clients/Index": 2450,
	"./Clients/Index.vue": 2450,
	"./ClientsCategories/Create": 1372,
	"./ClientsCategories/Create.vue": 1372,
	"./ClientsCategories/Edit": 9240,
	"./ClientsCategories/Edit.vue": 9240,
	"./ClientsCategories/Index": 9977,
	"./ClientsCategories/Index.vue": 9977,
	"./ClientsTypes/Create": 8166,
	"./ClientsTypes/Create.vue": 8166,
	"./ClientsTypes/Edit": 8569,
	"./ClientsTypes/Edit.vue": 8569,
	"./ClientsTypes/Index": 1860,
	"./ClientsTypes/Index.vue": 1860,
	"./Dashboard/DetailRoute": 4888,
	"./Dashboard/DetailRoute.vue": 4888,
	"./Dashboard/Details": 9652,
	"./Dashboard/Details.vue": 9652,
	"./Dashboard/Index": 6875,
	"./Dashboard/Index.vue": 6875,
	"./Dashboard/Journey": 1574,
	"./Dashboard/Journey.vue": 1574,
	"./Discounts/Create": 9784,
	"./Discounts/Create.vue": 9784,
	"./Discounts/Edit": 6505,
	"./Discounts/Edit.vue": 6505,
	"./Discounts/Index": 5267,
	"./Discounts/Index.vue": 5267,
	"./Liquidation/Index": 7283,
	"./Liquidation/Index.vue": 7283,
	"./Liquidation/Report": 5634,
	"./Liquidation/Report.vue": 5634,
	"./Orders/Employee": 9582,
	"./Orders/Employee.vue": 9582,
	"./Orders/Index": 5001,
	"./Orders/Index.vue": 5001,
	"./Orders/ProductOrdersReport": 8708,
	"./Orders/ProductOrdersReport.vue": 8708,
	"./Orders/Report": 698,
	"./Orders/Report.vue": 698,
	"./Orders/show": 3377,
	"./Orders/show.vue": 3377,
	"./Prices/Create": 2989,
	"./Prices/Create.vue": 2989,
	"./Prices/Edit": 7147,
	"./Prices/Edit.vue": 7147,
	"./Prices/Index": 8950,
	"./Prices/Index.vue": 8950,
	"./Prices/Products": 3886,
	"./Prices/Products.vue": 3886,
	"./Products/Create": 5715,
	"./Products/Create.vue": 5715,
	"./Products/Edit": 6761,
	"./Products/Edit.vue": 6761,
	"./Products/Index": 4783,
	"./Products/Index.vue": 4783,
	"./ProductsCategories/Create": 9875,
	"./ProductsCategories/Create.vue": 9875,
	"./ProductsCategories/Edit": 8516,
	"./ProductsCategories/Edit.vue": 8516,
	"./ProductsCategories/Index": 2805,
	"./ProductsCategories/Index.vue": 2805,
	"./ProductsDiscounts/Create": 7688,
	"./ProductsDiscounts/Create.vue": 7688,
	"./ProductsDiscounts/Edit": 2531,
	"./ProductsDiscounts/Edit.vue": 2531,
	"./ProductsDiscounts/Index": 2159,
	"./ProductsDiscounts/Index.vue": 2159,
	"./ProductsFamilies/Create": 9526,
	"./ProductsFamilies/Create.vue": 9526,
	"./ProductsFamilies/Edit": 5391,
	"./ProductsFamilies/Edit.vue": 5391,
	"./ProductsFamilies/Index": 1845,
	"./ProductsFamilies/Index.vue": 1845,
	"./ProductsGlobalDiscounts/Index": 9220,
	"./ProductsGlobalDiscounts/Index.vue": 9220,
	"./ProductsTax/Create": 7641,
	"./ProductsTax/Create.vue": 7641,
	"./ProductsTax/Edit": 2774,
	"./ProductsTax/Edit.vue": 2774,
	"./ProductsTax/Index": 1711,
	"./ProductsTax/Index.vue": 1711,
	"./ProductsUnits/Create": 5031,
	"./ProductsUnits/Create.vue": 5031,
	"./ProductsUnits/Edit": 3026,
	"./ProductsUnits/Edit.vue": 3026,
	"./ProductsUnits/Index": 1020,
	"./ProductsUnits/Index.vue": 1020,
	"./Reports/Index": 2682,
	"./Reports/Index.vue": 2682,
	"./Routes/ClientList": 6540,
	"./Routes/ClientList.vue": 6540,
	"./Routes/Clients": 6457,
	"./Routes/Clients.vue": 6457,
	"./Routes/Edit": 1815,
	"./Routes/Edit.vue": 1815,
	"./Routes/Index": 6819,
	"./Routes/Index.vue": 6819,
	"./Routes/IndexEmployeeRoute": 4658,
	"./Routes/IndexEmployeeRoute.vue": 4658,
	"./Routes/Sub_Routes/DaySubRoute": 2271,
	"./Routes/Sub_Routes/DaySubRoute.vue": 2271,
	"./Routes/Sub_Routes/Edit": 1342,
	"./Routes/Sub_Routes/Edit.vue": 1342,
	"./Routes/Sub_Routes/EditDay": 7126,
	"./Routes/Sub_Routes/EditDay.vue": 7126,
	"./Routes/Sub_Routes/Index": 163,
	"./Routes/Sub_Routes/Index.vue": 163,
	"./Routes/Sub_Routes/SubroutesList": 4770,
	"./Routes/Sub_Routes/SubroutesList.vue": 4770,
	"./Routes/Visits/Index": 935,
	"./Routes/Visits/Index.vue": 935,
	"./Users/Create": 3853,
	"./Users/Create.vue": 3853,
	"./Users/Edit": 6080,
	"./Users/Edit.vue": 6080,
	"./Users/Index": 3386,
	"./Users/Index.vue": 3386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;